import React, { useState } from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import "../PartnerManagement/Style.css";
import { leadActivationDetailsDetails } from "../../redux/LeadManagement/actions";
import UserManagementListing from "./UserManagementListing";
import AddUserDetails from "../AddUserDetails/AddUserDetails";
import PartnerPortalStatusBar from "../PartnerPortalStatusBar/PartnerPortalStatusBar";
import ChangePassword from "../../containers/Pages/Login/ChangePassword";
import Logout from "../../containers/Pages/Login/Logout";
import useWindowSize from "../../utils/useWindowSize";

const UserManagement = (props) => {
  const { width } = useWindowSize();

  const [partnerRefresh, setPartnerRefresh] = useState(false);

  const adminFirstName = (adminName) => {
    if (adminName) return adminName?.toUpperCase()?.charAt(0);
    else return null;
  };

  const adminLastName = (adminLast) => {
    if (adminLast) return adminLast?.toUpperCase()?.charAt(0);
    else return null;
  };

  return (
    <div>
      {/* <PartnerPortalStatusBar
        percent={90}
        lable={"90% Registration Completed"}
      /> */}
      {width > 786 && (
        <Row>
          <Col lg={12} xs={12} md={12} sm={12} className="partnerHeadre">
            <Col md={8} className="search-bar"></Col>

            <Col md={4}>
              <div className="login-profie">
                <div className="img-sec">
                  <h2>
                    {adminFirstName(
                      props.userDetail?.firstName ??
                        props.userDetail?.userName?.split(" ")[0]?.trim()
                    )}
                  </h2>
                  <h2>
                    {adminLastName(
                      props.userDetail?.lastName ??
                        props.userDetail?.userName?.split(" ")[1]?.trim()
                    )}
                  </h2>
                </div>

                <div className="content-login">
                  <h4>{props.userDetail?.userName}</h4>
                  <h5>{props.userDetail?.roleName}</h5>
                  <div className="content-login-data">
                    <ChangePassword />
                    <div className="admin-small-space"> </div>
                    <Logout />
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      )}
      <div style={{ marginTop: "10%" }} id="documents-main-sec">
        <AddUserDetails
          partnerRefresh={partnerRefresh}
          setPartnerRefresh={setPartnerRefresh}
        />
        <Row className="" style={{ maxWidth: "100%" }}>
          <Col md={12} style={{ maxWidth: "100%", overflow: "hidden" }}>
            <UserManagementListing
              partnerRefresh={partnerRefresh}
              setPartnerRefresh={setPartnerRefresh}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    leadActivationDetailsDetails: (data) =>
      dispatch(leadActivationDetailsDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    state: state.auth,
    userDetail: state.auth?.userData,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
